import React, { useMemo } from 'react';
import PageContent from 'components/subscriber/employer-profile';
import {
  EmployerProfilePageStore,
  EmployerProfilePageStoreContext,
} from 'store/pages/subscriber/employer-profile/pageStore';

// TESTING_POLICY: CYPRESS_ONLY

const EmployerProfilePage: React.FC = () => {
  const pageStore = useMemo(() => new EmployerProfilePageStore(), []);

  return (
    <EmployerProfilePageStoreContext.Provider value={pageStore}>
      <PageContent />
    </EmployerProfilePageStoreContext.Provider>
  );
};

export default EmployerProfilePage;
